import React from 'react';
import { Mail, MapPin, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';

export const ContactSection = ({ companyInfo, formData, onInputChange, onSubmit }) => (
  <section id="contact" className="py-12 md:py-16 lg:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Schedule a Consultation</h2>
        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto">
          Let's discuss how we can protect your business and ensure compliance
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
        <Card className="border-slate-200">
          <CardHeader>
            <CardTitle className="text-slate-900">Get in Touch</CardTitle>
            <CardDescription>Fill out the form and we'll respond within 24 hours</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label htmlFor="name">Name *</Label>
                <Input id="name" name="name" value={formData.name} onChange={onInputChange} required className="mt-1" />
              </div>
              <div>
                <Label htmlFor="email">Email *</Label>
                <Input id="email" name="email" type="email" value={formData.email} onChange={onInputChange} required className="mt-1" />
              </div>
              <div>
                <Label htmlFor="company">Company</Label>
                <Input id="company" name="company" value={formData.company} onChange={onInputChange} className="mt-1" />
              </div>
              <div>
                <Label htmlFor="phone">Phone</Label>
                <Input id="phone" name="phone" type="tel" value={formData.phone} onChange={onInputChange} className="mt-1" />
              </div>
              <div>
                <Label htmlFor="message">Message *</Label>
                <Textarea id="message" name="message" value={formData.message} onChange={onInputChange} required rows={4} className="mt-1" />
              </div>
              <Button type="submit" className="w-full bg-[#105EFF] hover:bg-[#0D4FCC] text-white">Submit Request</Button>
            </form>
          </CardContent>
        </Card>
        <div className="space-y-6">
          <Card className="border-slate-200">
            <CardHeader>
              <CardTitle className="text-slate-900">Contact Information</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-[#105EFF] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm text-slate-600">Email</p>
                  <p className="text-slate-900 font-medium">{companyInfo.email}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#105EFF] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm text-slate-600">Location</p>
                  <p className="text-slate-900 font-medium">{companyInfo.address}</p>
                </div>
              </div>
            </CardContent>
          </Card>
          <Card className="border-slate-200 bg-slate-50">
            <CardContent className="pt-6">
              <h4 className="font-semibold text-slate-900 mb-4">Why Choose Us?</h4>
              <ul className="space-y-2">
                {["Free initial consultation", "24-hour response time", "Proven track record", "Tailored solutions for SMEs"].map((item) => (
                  <li key={item} className="flex items-start space-x-2">
                    <CheckCircle className="h-5 w-5 text-[#105EFF] flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </section>
);
